import { DragDropModule } from '@angular/cdk/drag-drop';
import { Component, ElementRef, Inject, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { ADGroup } from '../../../models/ad-group';
import { Observable, Subject, startWith, map, filter, debounceTime, switchMap, combineLatest } from 'rxjs';
import { Group } from '../../../models/group';
import { ADADGroupService } from '../../../services/adGroup.service';
import { AdGroupChooserComponent } from '../../ad-group-chooser/ad-group-chooser.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { User } from '../../../models/user';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ad-groups-chooser-dialog',
    imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatSelectModule,
    AdGroupChooserComponent,
    DragDropModule,
    MatCheckboxModule,
    CommonModule,
    MatSnackBarModule,
    MatListModule,
  ],
  standalone: true,
  templateUrl: './ad-groups-chooser-dialog.component.html',
  styleUrl: './ad-groups-chooser-dialog.component.scss'
})
export class AdGroupsChooserDialogComponent {
  @ViewChild('adGroupFilterInput', {static: false}) input!: ElementRef<HTMLInputElement>;
  title: string = "Add members to group ";
  group!: WritableSignal<Group>;

  tagControl = new FormControl('');
  adGroupFilter = new FormControl('');
  membershipType = new FormControl('');
  filteredTags$: Observable<string[]>;
  adGroupDataSource = new MatTableDataSource<ADGroup>([]);
  selectedADGroups: ADGroup[] = [];
  chosenADGroups: ADGroup[] = [];
  adGroupMembers: { [key: string]: User[] } = {};
  allTags: string[] = ['Admin', 'Finance', 'HR', 'IT', 'Root']; // Example tag list
  displayedColumns: string[] = ['name', 'association', 'tools'];
  _options = new Subject<ADGroup[]>();
  options = this._options.asObservable();
  _filter = new Subject<string>();
  filter = this._filter.asObservable();
  flattenedMembers: User[] = [];
  selectedOptions: User[] = [];
  constructor(
    public dialogRef: MatDialogRef<AdGroupsChooserDialogComponent>,
    private adGroupService: ADADGroupService, private groupMembersService: ADADGroupService,
    private _snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { title: string }
  ) {
    // this.group = signal(data.group);
    this.title = this.data?.title ?? "Add AD group members...";
    this.filteredTags$ = this.tagControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterTags(value || ''))
    );
    this.filter.pipe(
      filter(c => !! c?.trim()),
      debounceTime(100),
      switchMap(c => { console.log("VVVVV", c); return this.adGroupService.filterADGroups([ { chip: null, value: c.trim() }], 5); })
    ).subscribe(resp => this._options.next(resp.groups));
  }

  private _filterTags(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter((tag) =>
      tag.toLowerCase().includes(filterValue)
    );
  }

  itemComparer: (a: User, b: User) => boolean = ((a, b) => a.hawkId == b.hawkId);

  getItemName(item: User) {
    return `${item.displayName} (${item.hawkId})`;
  }

  getId(item: User) {
    return item.hawkId;
  }
  
  filterADGroups() {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this._filter.next(filterValue);
  }

  async adGroupsChange(adGroups: ADGroup[]) {
    this.chosenADGroups = adGroups;
    for (let adGroup of adGroups) {
      if (!this.adGroupMembers[adGroup.group]) {
        const members = await this.adGroupService.fetchADGroupMembers(adGroup.group);
        if (members.length > 0) {
          this.adGroupMembers[adGroup.group] = members;
        } else {
          this._snackbar.open(`Warning: AD group '${adGroup.group}' was empty or had no TKS members.`, undefined, { duration: 3000, verticalPosition: 'top' });
        }
      }
    }
    this.flattenedMembers = Object.values(
      adGroups
        .map(g => g.group)
        .flatMap(k => this.adGroupMembers[k] ? this.adGroupMembers[k] : [])
        .reduce((acc, m) => { acc[m.hawkId] = m; return acc; }, <{[k: string]: User}>{}) // make distinct via object
      );
    this.selectedOptions = this.flattenedMembers;
    console.log(arguments, this.adGroupFilter.value, Object.keys(this.adGroupMembers), this.flattenedMembers);
  }

  selectionChanged($event: any) {

  }

  log(s: string) {}

  cancel() {
    this.dialogRef.close();
  }

  formatADGroupFn(adGroup: ADGroup) {
    return adGroup ? adGroup.displayName : '';
  }

  addMembers() {
    console.log(this.selectedOptions, this.flattenedMembers);
    this.dialogRef.close([ this.chosenADGroups, this.selectedOptions ]);
  }
}
